import React, { useState } from 'react'

import { Button, Form, Input, Modal, Typography } from 'antd'
import { useGenerateIntegrationToken } from '../hooks'
import { GenerateInput } from '../input/generate-input'
import { IntegrationTokenWithPlainText } from '../integration-token'
import { t } from 'i18next'
import useForm from '../../hooks/use-form'

type Props = {
    open: boolean
    onCancel: () => void
}

export function GenerateModal({ open, onCancel }: Props) {
    const [form] = Form.useForm<GenerateInput>()
    const [generatedToken, setGeneratedToken] = useState<IntegrationTokenWithPlainText | null>(null)
    const mutation = useGenerateIntegrationToken()

    const formProps = useForm({
        mutation,
        onSuccess: (token) => {
            setGeneratedToken(token)
            form.resetFields()
            formProps.form.resetFields()
        },
    })

    const handleClose = () => {
        setGeneratedToken(null)
        form.resetFields()
        onCancel()
    }

    if (generatedToken) {
        return (
            <Modal
                title={t('Integration Token Generated')}
                open={open}
                onCancel={handleClose}
                footer={[
                    <Button
                        key="close"
                        onClick={handleClose}
                    >
                        {t('Close')}
                    </Button>,
                ]}
            >
                <div className="space-y-4">
                    <Typography.Text>
                        {t(
                            'Your integration token has been generated. Please copy it now as it will not be shown again.'
                        )}
                    </Typography.Text>
                    <Typography.Paragraph>
                        <pre>
                            <Typography.Text
                                code
                                copyable
                            >
                                {generatedToken.plainTextToken}
                            </Typography.Text>
                        </pre>
                    </Typography.Paragraph>
                    <Typography.Text type="warning">
                        {t('Store this token securely and never share it publicly.')}
                    </Typography.Text>
                </div>
            </Modal>
        )
    }

    return (
        <Modal
            title={t('Generate Integration Token')}
            open={open}
            onCancel={onCancel}
            footer={null}
        >
            <Form
                {...formProps}
                layout="vertical"
            >
                <Form.Item
                    name="name"
                    label={t('Token Name')}
                >
                    <Input placeholder={t('e.g., API Integration, Webhook Service')} />
                </Form.Item>

                <Form.Item className="mb-0">
                    <div className="flex justify-end space-x-2">
                        <Button onClick={onCancel}>{t('Cancel')}</Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={mutation.isPending}
                        >
                            {t('Generate Token')}
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    )
}
